import * as yup from 'yup';

export const schema = yup.object({
  des_banco: yup.string().trim().required(),
  cod_banco: yup.number().min(0).required(),
});
